import axios from "axios"
import pubsub  from "@viewlift/pubsub"
import { getDeviceId } from "../../../helpers";
import trackEvent from "./analyticsMap";
import { FB_EVENTS } from "../../../helpers/analyticsMap";


  if(window.FB){ 
  window.fbAsyncInit = function() {
    // eslint-disable-next-line no-undef
    FB.init({
      appId      : '438613078344683',
      cookie     : true,
      xfbml      : true,
      version    : 'v15.0',
      channelUrl : 'http://localhost:8083/'
    });
      
    window.FB.AppEvents.logPageView();   

    window.FB.Event.subscribe('auth.statusChange', function(resp) {
        console.log('first response',resp)
        window.FB.getLoginStatus(function(response){
            checkFacebookLoginStatusCallback(response)
        })

    });
      
  };}

  function checkFacebookLoginStatusCallback(response) {  // Called with the results from FB.getLoginStatus().
    console.log(' Checking Facebook Login Status');
    console.log(response);                   // The current login status of the person.
    if (response.status === 'connected') {   // Logged into your webpage and Facebook.
    //   getUserProfile();  
    console.log('connected')
    } else {                                 // Not logged into your webpage or we are unable to tell.
        console.log("couldn't connect")
    }
  }
  

export let initializeFacebookLogin = () => {

  (function(d, s, id){
     var js, fjs = d.getElementsByTagName(s)[0];
     if (d.getElementById(id)) {return;}
     js = d.createElement(s); js.id = id;
     js.src = "https://connect.facebook.net/en_US/sdk.js";
     fjs.parentNode.insertBefore(js, fjs);
   }(document, 'script', 'facebook-jssdk'));

}    


export let fbLogin = (user,generateId) => {

    const dataLayer = window.dataLayer || { push: _ => {} }
    let apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl
    var deviceId = getDeviceId();
    var loginParams = {
      site: window.settings.internalName,
      deviceId:deviceId,
      platform : "web_browser"
    }
  
    var payload = axios({
      method: 'POST',
      url: `${apiBaseUrl}/identity/signin/facebook`,
      params: loginParams,
      headers: {
        'x-api-key': window?.xApiKey
      },
      data: {
        facebookToken: user.facebookToken,
        emailConsent: user.emailConsent
      }
    }).then( res => {
      localStorage.setItem('deviceId', deviceId);
      trackEvent('login', {method: "Facebook"},null)
      dataLayer.push({
        'event': 'avod_finish_registration',
        'registration_method': 'facebook'
      });
      pubsub.publish('FB-analytics',{eventType : FB_EVENTS.LOGIN ,payload : {platform: 'Web', registrationType: 'Facebook'},type : "FB"})
      return res.data
    })
  
    return { type: 'LOGIN', payload: payload }
  }